var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowfandb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0V2.57143H2.5C1.125 2.57143 0 3.72857 0 5.14286V7.71429H2.5V5.14286H15V7.71429L20 3.85714L15 0ZM5 10.2857L0 14.1429L5 18V15.4286H17.5C18.875 15.4286 20 14.2714 20 12.8571V10.2857H17.5V12.8571H5V10.2857Z",
    fill: "#034EA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowfandb);
export default __webpack_public_path__ + "static/media/arrowfandb.0a84a06d72a64978081a54205aca964d.svg";
export { ForwardRef as ReactComponent };